// Note
// Services that can't get injected due to circular dependency injection at the moment:
// - TeamDataProvider

// Note
// Service declared as function for now due to window or scope copy error for the classes where this
// Service gets passed.

import * as angular from "angular";
import { Campaign } from "../models/campaign.model";
import { EventModel } from "../models/event.model";
import { Appointment } from "../models/appointment.model";
import { Assignment } from "../models/assignment.model";
import { Group } from "../models/group.model";
import { House } from "../models/house.model";
import { Building } from "../models/building.model";
import { HouseOccupant } from "../models/house-occupant.model";
import { Invite } from "../models/invite.model";
import { Issue } from "../models/issue.model";
import { Organisation } from "../models/organisation.model";
import { OrganisationInvite } from "../models/organisation-invite.model";
import { Feature } from "../models/feature.model";
import { Team } from "../models/team.model";
import { User } from "../models/user.model";
import { DocumentModel } from "../models/document.model";
import { UserService } from "../services/users.service";
import { TeamService } from "../services/team.service";
import { ApiUserService } from "../services/user.service";
import { TeamColorDataProvider } from "../data-provider/team-color.dp";
import { FeatureService } from "../services/feature.service";
import { HouseService } from "../services/house.service";
import { BuildingService } from "../services/building.service";
import { GroupService } from "../services/group.service";
import { DialogUtils } from "./dialog.helper";
import { HouseOccupantService } from "../services/house-occupant.service";
import { DocumentService } from "../services/document.service";
import { VoterFile } from "../models/voter-file.model";
import { VoterFileImport } from "../models/voter-file-import.model";
import { SubscriptionDataProvider } from "../data-provider/subscription.dp";
import { VoterFileService } from "../services/voter-file.service";
import { AppointmentFilter } from "../models/appointment-filter.model";
import { AssignmentFilter } from "../models/assignment-filter.model";

function ModelsUtils(
    UserService: UserService,
    TeamService: TeamService,
    $q: any,
    ApiUserService: ApiUserService,
    __env: any,
    SubscriptionDataProvider: SubscriptionDataProvider,
    TeamColorDataProvider: TeamColorDataProvider,
    localStorageService: any,
    FeatureService: FeatureService,
    BuildingService: BuildingService,
    HouseService: HouseService,
    GroupService: GroupService,
    DialogUtils: DialogUtils,
    $filter: any,
    HouseOccupantService: HouseOccupantService,
    DocumentService: DocumentService,
    VoterFileService: VoterFileService
) {
    return {
        user(data?: object): User {
            return new User(
                UserService,
                TeamService,
                $q,
                $filter,
                ApiUserService,
                __env,
                SubscriptionDataProvider,
                TeamColorDataProvider,
                localStorageService,
                data
            );
        },

        campaign(data?: object): Campaign {
            return new Campaign(localStorageService, $q, data);
        },

        feature(data?: object): Feature {
            return new Feature($q, FeatureService, data);
        },

        organisation(data?: object): Organisation {
            return new Organisation(localStorageService, data);
        },

        organisationInvite(data?: object): OrganisationInvite {
            return new OrganisationInvite(TeamColorDataProvider, data);
        },

        issue(data?: object): Issue {
            return new Issue(this, data);
        },

        house(data?: object): House {
            return new House($q, HouseService, data);
        },

        building(data?: object): Building {
            return new Building($q, BuildingService, data);
        },

        group(data?: object): Group {
            return new Group(GroupService, $q, this, data);
        },

        houseOccupant(data?: object): HouseOccupant {
            return new HouseOccupant(
                HouseOccupantService,
                $q,
                __env,
                $filter,
                data
            );
        },

        event(data?: object): EventModel {
            return new EventModel(this, TeamColorDataProvider, data);
        },

        appointment(data?: object): Appointment {
            return new Appointment(this, data);
        },

        invite(data?: object): Invite {
            return new Invite(TeamColorDataProvider, data);
        },

        document(data?: object): DocumentModel {
            return new DocumentModel(data, DocumentService, $q);
        },

        team(data?: object): Team {
            return new Team(TeamColorDataProvider, this, data);
        },

        voterFile(data?: object): VoterFile {
            return new VoterFile(VoterFileService, $q, this, data);
        },

        import(data?: object): VoterFileImport {
            return new VoterFileImport(VoterFileService, $q, data);
        },

        appointmentFilter(data?: object): AppointmentFilter {
            return new AppointmentFilter(localStorageService, data);
        },
        assignment(data?: object): Assignment {
            return new Assignment(this, data);
        },
        assignmentFilter(data?: object): AssignmentFilter {
            return new AssignmentFilter(data);
        },
    };
}

angular.module("vcHelper").service("ModelsUtils", ModelsUtils);
